import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Services from './layout/services/services';
import Header from './components/header/header';
import Footer from './components/footer/footer';
import Home from './layout/home/home';
import AboutUs from './layout/about/about';
import ContactUsPage from './layout/contact/contact';
import ExecutiveSearch from './layout/executivesearch/executivesearch';
import ErrorPage from './layout/errorPage/ErrorPage'; // Import your ErrorPage component
import ImprintPage from './layout/imprint/ImprintPage';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' 
    });
  }, [pathname]);

  return null;
}
function App() {
  return (
    <Router>
       <ScrollToTop /> 
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<ContactUsPage />} />
          <Route path="/executivesearch" element={<ExecutiveSearch/>} />
          <Route path="/imprint" element={<ImprintPage/>} />
          
          <Route path="*" element={<ErrorPage />} />
        </Routes>
        <Footer/>
    </Router>
  );
}

export default App;